// extracted by mini-css-extract-plugin
export default {"loader":"RankingAvatarsList_loader__NXVEO","fullRow":"RankingAvatarsList_fullRow__0My3N","notFound":"RankingAvatarsList_notFound__1T-LY"};